"use client"

import { useSnapshot } from "valtio"
import { AccountState } from "../../stores/accountStore"

export function useAccount() {
  const account = useSnapshot(AccountState)
  return account
}
